import { Typography } from '@workspace/ui/components/Typography';
import { useBreakpoint } from '@workspace/ui/hooks/useBreakpoint';

import { cn } from '@workspace/ui/lib/utils';
import { forwardRef } from 'react';

import type { FooterProps } from './Footer';
import { useFooterSlots } from './useFooterSlots';

export const FooterMCosmetic = forwardRef<HTMLDivElement, FooterProps>(
  ({ logo, logoWidth = 'w-78', name, children, className, ...props }, ref) => {
    const slots = useFooterSlots(children);
    const { isMobile } = useBreakpoint();

    if (isMobile) return null;

    const LogoDesktop = logo.desktop;

    return (
      <footer
        {...props}
        ref={ref}
        className={cn(
          'flex flex-col bg-bg-base px-15 pt-15 text-text-primary',
          'rounded-t-7 border-stroke-secondary border-t',
          className,
        )}
      >
        {slots.topSection && <div className="flex">{slots.topSection}</div>}
        <div className="mt-10 grid grid-cols-[1fr_312px_1fr] items-center border-stroke-secondary border-t py-15">
          {slots.socials}
          <div className={`flex justify-center align-center`}>
            {LogoDesktop && (
              <LogoDesktop
                aria-label="logo"
                className="h-[46px] text-graphic-regular-brand"
              />
            )}
          </div>
          <Typography.Text100RegularHigh className="text-end">
            © {new Date().getFullYear()} {name} All rights reserved.
          </Typography.Text100RegularHigh>
        </div>
      </footer>
    );
  },
);
FooterMCosmetic.displayName = 'FooterMCosmetic';
